import { render } from "./spendingActivityRecorder.vue?vue&type=template&id=4dc2c2e2&scoped=true&ts=true"
import script from "./spendingActivityRecorder.vue?vue&type=script&lang=ts"
export * from "./spendingActivityRecorder.vue?vue&type=script&lang=ts"

import "./spendingActivityRecorder.vue?vue&type=style&index=0&id=4dc2c2e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc2c2e2"]])

export default __exports__